import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays, Check } from 'lucide-react';
import { LAUNCH_TOGETHER } from '@/data/launch';
import { SlashMark } from '../AmdenMark';
import { Reveal } from '../Reveal';

const ACCENT = '#4225C4';
const ACCENT_SOFT = '#E4E0FA';

export const EverythingTogether = () => (
  <section aria-labelledby="together-heading" data-testid="together-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest" style={{ color: ACCENT }}>06</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: ACCENT }}>
              {LAUNCH_TOGETHER.eyebrow}
            </span>
          </p>
          <h2 id="together-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            {LAUNCH_TOGETHER.heading}
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
            {LAUNCH_TOGETHER.copy}
          </p>
          <ul className="mt-8 space-y-3.5">
            {LAUNCH_TOGETHER.points.map((point) => (
              <li key={point} className="flex items-start gap-3 text-sm font-semibold text-navy-800 sm:text-base">
                <span
                  className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full"
                  style={{ backgroundColor: ACCENT_SOFT }}
                >
                  <Check className="h-3 w-3" style={{ color: ACCENT }} aria-hidden="true" />
                </span>
                {point}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            data-testid="launch-consultation-card"
            className="relative overflow-hidden rounded-2xl bg-navy-900 p-8 sm:p-12"
          >
            <SlashMark
              className="pointer-events-none absolute -bottom-10 -right-10 h-52 w-52 opacity-[0.06]"
              bar="#ffffff"
              dot="#4225C4"
            />
            <span
              className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-white"
              style={{ backgroundColor: `${ACCENT}40` }}
            >
              <CalendarDays className="h-3.5 w-3.5" aria-hidden="true" />
              {LAUNCH_TOGETHER.consultation.label}
            </span>
            <h3 className="mt-6 text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
              {LAUNCH_TOGETHER.consultation.heading}
            </h3>
            <p className="mt-4 max-w-sm text-base leading-relaxed text-slate-300">
              {LAUNCH_TOGETHER.consultation.copy}
            </p>
            <Link
              to={LAUNCH_TOGETHER.consultation.href}
              data-testid="consultation-card-btn"
              className="group mt-8 inline-flex items-center gap-2 rounded-md px-6 py-3.5 text-sm font-bold text-white transition-colors"
              style={{ backgroundColor: ACCENT }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#331BA0')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = ACCENT)}
            >
              {LAUNCH_TOGETHER.consultation.button}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
